"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Align = _interopRequireDefault(require("./Align"));

// export this package's api
var _default = _Align.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/rc-align/lib/index.js
// module id = 1100
// module chunks = 0